import request from "@/utils/request";

/**密码登录 */
export function login(data) {
  return request({
    url: "/v1/6459ea02ba473",
    method: "post",
    data,
  });
}
/**获取验证码 */
export function getCode(data) {
  return request({
    url: "/v1/5b5bdc44796e8",
    method: "post",
    data,
  });
}

/**用户注册 */
export function userRegister(data) {
  return request({
    url: "/v1/645b0ae5e26ba",
    method: "post",
    data,
  });
}

/**获取用户信息 */
export function userInfo() {
  return request({
    url: "/v1/6486f3c53f10f",
    method: "post",
  });
}

/**旧密码修改密码 */
export function formerAmendPassword(data) {
  return request({
    url: "/v1/65588ad85b026",
    method: "post",
    data,
  });
}

/**忘记密码（验证码重置）*/
export function mobileAmendPassword(data) {
  return request({
    url: "/v1/6486ca3fadf64",
    method: "post",
    data,
  });
}

/**更换绑定账号 */
export function changeAccount(data) {
  return request({
    url: "/v1/6486d2a264ce5",
    method: "post",
    data,
  });
}

/**校验验证码 */
export function verifyCode(data) {
  return request({
    url: "/v1/655886cbda89b",
    method: "post",
    data,
  });
}

export function getInfo(token) {
  return request({
    url: "/v1/6486f3c53f10f",
    method: "post",
    params: { token },
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js